import React, { useState, useEffect } from "react";
import qscoinprice from "../../data/qscoinprice";
import { DiscountBanner } from "../compIndex";
import { Link } from "react-router-dom";

const CoinQSComp = () => {
  const [coinprices, setcoinPrices] = useState([]);
  const [qsprices, setqsPrices] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const coins = [];
        const qs = [];

        for (const key in qscoinprice) {
          const item = qscoinprice[key];
          if (item.itemid.startsWith("itm_coin")) {
            coins.push(item);
          } else {
            qs.push(item);
          }
        }

        setqsPrices(qs);
        setcoinPrices(coins);
      } catch (error) {
        console.log("Issue setting coin and QS prices: ", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <h1 className="home-title">Coin Prices</h1>
      <div>
        <div className="flex md:justify-center md:flex-wrap overflow-x-auto md:overflow-x-visible gap-3 md:gap-4 pb-4 -mx-2 px-2 md:mx-0 md:px-0">
          {coinprices.map((price) => (
            <div
              key={price.uid}
              className="flex-shrink-0 w-64 md:w-56 bg-[var(--entity-bg-color)] text-[var(--font-color)] p-3 md:p-4 border-solid border-2 border-[var(--button2-bg-color)] rounded-md hover:bg-[var(--entity-hover-bg-color)]"
            >
              <img src={price.image} alt={price.name} className="h-12 mx-auto" />
              <div className="font-bold">{price.name}</div>
              <div className="items-center text-center text-sm">
                <img
                  src="https://d31ss916pli4td.cloudfront.net/uploadedAssets/currency/pixels_pixel_currency_new_2.png"
                  className="h-6 ml-1 inline"
                  alt="pixel"
                />{" "}
                {price.price.toLocaleString()}
              </div>

              <div className="bg-[var(--panel-bg-color)] rounded p-2 text-xs">
                Less 5%:
                <img
                  src="https://d31ss916pli4td.cloudfront.net/uploadedAssets/currency/pixels_pixel_currency_new_2.png"
                  className="h-3 ml-1 inline"
                  alt="pixel"
                />{" "}
                {(price.price - price.price * 0.05).toLocaleString()} <br />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="panel-button">
      <Link to="./tools/calculator">
        <span>Use the Pixelore Calculator to calculate $PIXEL to Coin Earnings</span>
      </Link>
      </div>

      <h1 className="home-title">Quicksilver Prices</h1>
      <div className="mt-2">
        <div className="flex md:justify-center md:flex-wrap overflow-x-auto md:overflow-x-visible gap-3 md:gap-4 pb-4 -mx-2 px-2 md:mx-0 md:px-0">
          {qsprices.map((price) => (
            <div
              key={price.uid}
              className="flex-shrink-0 w-64 md:w-56 bg-[var(--entity-bg-color)] text-[var(--font-color)] p-3 md:p-4 border-solid border-2 border-[var(--button2-bg-color)] rounded-md hover:bg-[var(--entity-hover-bg-color)]"
            >
              <img src={price.image} alt={price.name} className="h-12 mx-auto" />
              <div className="font-bold">{price.name}</div>
              <div className="items-center text-center text-sm">
                <img
                  src="https://d31ss916pli4td.cloudfront.net/uploadedAssets/currency/pixels_pixel_currency_new_2.png"
                  className="h-6 ml-1 inline"
                  alt="pixel"
                />{" "}
                {price.price.toLocaleString()}
              </div>
              <div className="bg-[var(--panel-bg-color)] rounded p-2 text-xs">
                {price.itemid !== "itm_quick1" && (
                  <div className="items-center text-center text-xs">
                    Less 5%:
                    <img
                      src="https://d31ss916pli4td.cloudfront.net/uploadedAssets/currency/pixels_pixel_currency_new_2.png"
                      className="h-3 ml-1 inline"
                      alt="pixel"
                    />{" "}
                    {(price.price - price.price * 0.05).toLocaleString()} <br />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <DiscountBanner />
    </div>
  );
};

export default CoinQSComp;
